<form [formGroup]="formCompanyInfo" class="mt-2">

  <!-- HEADER -->
  <div class="border-b pb-4">
    <p class="font-medium text-base text-westetics-neutral-950">
      Informações
    </p>
    <p class="text-sm text-westetics-neutral-800 mt-2">
      Informe os dados da sua empresa nesta seção
    </p>
  </div>

  <!-- LOGO + POSIÇÃO -->
  <div class="border-b pb-4 mt-4 flex flex-col md:flex-row md:justify-between gap-4 md:gap-8 items-center">

    <!-- LOGO -->
    <div class="flex flex-col md:flex-row gap-4 md:gap-5 items-center w-full md:w-auto">
      <img
        *ngIf="getLogoUrl(); else defaultLogo"
        [src]="getLogoUrl()"
        class="w-20 h-20 md:w-[88px] md:h-[88px] rounded-full object-cover cursor-pointer hover:opacity-80 transition-opacity"
        (click)="openImagePreview()"
        title="Clique para ampliar"
      />
      <ng-template #defaultLogo>
        <img
          src="assets/icons/company-circle.svg"
          class="w-20 h-20 md:w-[88px] md:h-[88px]"
        />
      </ng-template>

      <div *ngIf="isRoot" class="w-full md:w-auto text-center md:text-left">
        <p class="font-medium text-base text-westetics-neutral-950">
          Escolha a Logo da empresa
        </p>
        <p class="text-sm text-westetics-neutral-800 mt-1">
          Min 200x200px, PNG ou JPEG
        </p>

        <div class="mt-3 flex flex-col sm:flex-row gap-2 items-stretch sm:items-center">
          <label class="inline-block cursor-pointer">
            <input
              type="file"
              hidden
              accept="image/png,image/jpeg,image/*"
              (change)="onFileSelect($event)"
            />
            <span
              class="h-9 px-3 py-1 text-sm rounded-lg border text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 inline-flex items-center justify-center w-full sm:w-auto text-center">
              {{ imageBinary ? 'Alterar' : 'Subir arquivo' }}
            </span>
          </label>
          
          <button
            *ngIf="imageBinary"
            type="button"
            (click)="resetImage()"
            class="h-9 px-3 py-1 text-sm rounded-lg border inline-flex items-center justify-center bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white">
            Excluir
          </button>
        </div>
      </div>
    </div>

    <!-- POSIÇÃO DO LOGO (apenas ROOT) -->
    <div *ngIf="isRoot" class="flex flex-col justify-center w-full md:w-auto mt-3 md:mt-0 text-center md:text-left">
      <p class="font-medium text-sm text-westetics-neutral-950">
        Posição do logo no template
      </p>

      <div class="mt-3 flex justify-center md:justify-start gap-4">
        <label class="flex items-center gap-2 cursor-pointer">
            <input
                type="radio"
                formControlName="imagePosition"
                value="header"
            />
            <span class="text-sm font-normal text-westetics-neutral-950">Cabeçalho</span>
        </label>

        <label class="flex items-center gap-2 cursor-pointer">
            <input
                type="radio"
                formControlName="imagePosition"
                value="watermark"
            />
            <span class="text-sm font-normal text-westetics-neutral-950">Marca d’água</span>
        </label>
      </div>
    </div>
  </div>

  <!-- CNPJ E RAZÃO SOCIAL -->
  <div class="border-b pb-4 mt-4">
        <div class="w-full">
            <label for="cnpj" class="block mb-2 text-sm font-medium text-westetics-neutral-950">CPF/CNPJ da
                Empresa*</label>
            <input maxlength="18" type="text" id="cnpj" formControlName="cnpj" inputmode="numeric"
                class="bg-gray-50 border disabled:border-none disabled:bg-gray-100 border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5 "
                placeholder="Insira o CPF ou CNPJ da Empresa" (input)="onCpfCnpjInput($event)" />
            <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
                formCompanyInfo.controls['cnpj']?.invalid &&
                formCompanyInfo.controls['cnpj']?.touched
                ">
                Insira um CPF ou CNPJ válido.
            </span>
        </div>

        <div class="w-full mt-4">
            <label for="corporateName" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Razão
                social*</label>
            <input type="text" id="corporateName" formControlName="corporateName"
                class="bg-gray-50 border disabled:border-none disabled:bg-gray-100 border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5 "
                placeholder="Insira a Razão Social" />
            <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
                formCompanyInfo.controls['corporateName']?.invalid &&
                formCompanyInfo.controls['corporateName']?.touched
                ">
                Insira uma razão social válida.
            </span>
        </div>
        
        <!-- Loading indicator for CNPJ auto-fill -->
        <div *ngIf="isLoadingCnpj" class="mt-2 flex items-center gap-2 text-sm text-westetics-purple-800">
          <app-loading-spinner size="sm"></app-loading-spinner>
          <span>Buscando dados do CNPJ...</span>
        </div>

        <!-- GRUPO PERTENCENTE (apenas ROOT na criação) -->
        <div *ngIf="isRoot && !isEditMode" class="w-full mt-4">
          <app-custom-dropdown
            [options]="clinicGroupOptions"
            [label]="'Grupo Pertencente'"
            [placeholder]="isLoadingGroups ? 'Carregando grupos...' : 'Selecione um grupo (opcional)'"
            [disabled]="isLoadingGroups"
            formControlName="groupId">
          </app-custom-dropdown>
        </div>
  </div>

  <!-- ENDEREÇO -->
  <div class="border-b pb-4 mt-4">
    <p class="font-medium text-sm text-westetics-neutral-950 mb-4">Endereço</p>

    <!-- CEP -->
    <div class="w-full">
      <label for="cep" class="block mb-2 text-sm font-medium text-westetics-neutral-950">CEP*</label>
      <div class="relative">
        <input
          maxlength="9"
          type="text"
          id="cep"
          formControlName="cep"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="00000-000"
          (input)="onCepInput($event)"
        />
        <div *ngIf="isLoadingCep" class="absolute right-3 top-1/2 -translate-y-1/2">
          <app-loading-spinner size="sm"></app-loading-spinner>
        </div>
      </div>
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyInfo.controls['cep']?.invalid &&
        formCompanyInfo.controls['cep']?.touched
      ">
        Insira um CEP válido.
      </span>
    </div>

    <!-- NOME DA RUA -->
    <div class="w-full mt-4">
      <label for="street" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Nome da Rua*</label>
      <input
        type="text"
        id="street"
        formControlName="street"
        class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Insira o nome da rua"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyInfo.controls['street']?.invalid &&
        formCompanyInfo.controls['street']?.touched
      ">
        Insira o nome da rua.
      </span>
    </div>

    <!-- NÚMERO E COMPLEMENTO -->
    <div class="mt-4 grid grid-cols-2 gap-4">
      <div class="w-full">
        <label for="number" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Número*</label>
        <input
          type="text"
          id="number"
          formControlName="number"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Número"
        />
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
          formCompanyInfo.controls['number']?.invalid &&
          formCompanyInfo.controls['number']?.touched
        ">
          Insira o número.
        </span>
      </div>

      <div class="w-full">
        <label for="complement" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Complemento</label>
        <input
          type="text"
          id="complement"
          formControlName="complement"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Apto, Bloco, Sala..."
        />
      </div>
    </div>

    <!-- BAIRRO -->
    <div class="w-full mt-4">
      <label for="neighborhood" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Bairro*</label>
      <input
        type="text"
        id="neighborhood"
        formControlName="neighborhood"
        class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
        placeholder="Insira o bairro"
      />
      <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
        formCompanyInfo.controls['neighborhood']?.invalid &&
        formCompanyInfo.controls['neighborhood']?.touched
      ">
        Insira o bairro.
      </span>
    </div>

    <!-- CIDADE E ESTADO -->
    <div class="mt-4 grid grid-cols-2 gap-4">
      <div class="w-full">
        <label for="city" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Cidade*</label>
        <input
          type="text"
          id="city"
          formControlName="city"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Insira a cidade"
        />
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
          formCompanyInfo.controls['city']?.invalid &&
          formCompanyInfo.controls['city']?.touched
        ">
          Insira a cidade.
        </span>
      </div>

      <div class="w-full">
        <label for="state" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Estado*</label>
        <input
          type="text"
          id="state"
          formControlName="state"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="UF"
          maxlength="2"
        />
        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
          formCompanyInfo.controls['state']?.invalid &&
          formCompanyInfo.controls['state']?.touched
        ">
          Insira o estado.
        </span>
      </div>
    </div>
  </div>

  <!-- TESTEMUNHAS (apenas ROOT) -->
  <div *ngIf="isRoot" class="border-b pb-4 mt-4">
    <p class="font-medium text-sm text-westetics-neutral-950 mb-4">Testemunhas</p>
    
    <!-- Primeira Testemunha -->
    <div class="grid grid-cols-2 gap-4">
      <div class="w-full">
        <label for="firstWitnessName" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Nome da Primeira Testemunha</label>
        <input
          type="text"
          id="firstWitnessName"
          formControlName="firstWitnessName"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Insira o nome da primeira testemunha"
        />
      </div>
      <div class="w-full">
        <label for="firstWitnessDocument" class="block mb-2 text-sm font-medium text-westetics-neutral-950">CPF da Primeira Testemunha</label>
        <input
          type="text"
          id="firstWitnessDocument"
          formControlName="firstWitnessDocument"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="000.000.000-00"
          mask="000.000.000-00"
          inputmode="numeric"
        />
      </div>
    </div>
    
    <!-- Segunda Testemunha -->
    <div class="grid grid-cols-2 gap-4 mt-4">
      <div class="w-full">
        <label for="secondWitnessName" class="block mb-2 text-sm font-medium text-westetics-neutral-950">Nome da Segunda Testemunha</label>
        <input
          type="text"
          id="secondWitnessName"
          formControlName="secondWitnessName"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Insira o nome da segunda testemunha"
        />
      </div>
      <div class="w-full">
        <label for="secondWitnessDocument" class="block mb-2 text-sm font-medium text-westetics-neutral-950">CPF da Segunda Testemunha</label>
        <input
          type="text"
          id="secondWitnessDocument"
          formControlName="secondWitnessDocument"
          class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="000.000.000-00"
          mask="000.000.000-00"
          inputmode="numeric"
        />
      </div>
    </div>
  </div>

  <!-- EMAIL JURÍDICO (somente leitura no modo edição) -->
  <div *ngIf="isEditMode" class="border-b pb-4 mt-4">
    <p class="font-medium text-sm text-westetics-neutral-950 mb-4">Email Jurídico</p>
    <div class="w-full">
      <input
        type="email"
        id="legalEmail"
        formControlName="legalEmail"
        class="bg-gray-100 border-none text-neutral-500 text-sm rounded-lg outline-none block w-full p-2.5"
      />
    </div>
  </div>
  
  <!-- API PARA TERCEIROS (Clinic Apps) - apenas ADMIN em modo edição -->
  <div class="border-b pb-4 mt-4" *ngIf="isAdmin && isEditMode">
    <div class="flex items-center justify-between">
      <p class="font-medium text-sm text-westetics-neutral-950">API para Terceiros</p>
      <button
        type="button"
        (click)="openCreateAppModal()"
        class="px-3 py-1.5 text-xs font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors"
      >
        + Novo App
      </button>
    </div>
    <p class="text-xs text-westetics-neutral-600 mt-1 mb-3">
      Gerencie apps de terceiros que acessam a API da clínica.
    </p>

    <!-- Loading -->
    <div *ngIf="clinicAppsLoading" class="text-neutral-400 text-xs py-4">Carregando...</div>

    <!-- Lista vazia -->
    <div *ngIf="!clinicAppsLoading && clinicApps.length === 0"
      class="text-center py-6 border border-dashed border-gray-300 rounded-lg">
      <p class="text-sm text-westetics-neutral-600">Nenhum app cadastrado.</p>
      <p class="text-xs text-westetics-neutral-500 mt-1">Clique em "+ Novo App" para criar.</p>
    </div>

    <!-- Lista de apps -->
    <div *ngIf="!clinicAppsLoading && clinicApps.length > 0" class="flex flex-col gap-3">
      <div *ngFor="let app of clinicApps"
        class="border border-gray-200 rounded-lg p-4">
        <div class="flex items-start justify-between">
          <div>
            <p class="text-sm font-medium text-westetics-neutral-950">{{ app.name }}</p>
            <p class="text-xs text-westetics-neutral-600 mt-0.5 font-mono">Key: {{ app.app_key }}</p>
          </div>
          <div class="flex gap-2">
            <button
              type="button"
              (click)="openEditScopesModal(app)"
              class="px-2 py-1 text-xs font-medium text-westetics-purple-800 border border-westetics-purple-800 rounded-lg hover:bg-westetics-purple-800 hover:text-white transition-colors"
            >
              Escopos
            </button>
            <button
              type="button"
              (click)="regenerateSecret(app)"
              class="px-2 py-1 text-xs font-medium text-westetics-purple-800 border border-westetics-purple-800 rounded-lg hover:bg-westetics-purple-800 hover:text-white transition-colors"
            >
              Regenerar
            </button>
            <button
              type="button"
              (click)="openDeleteAppModal(app)"
              class="px-2 py-1 text-xs font-medium text-red-600 border border-red-300 rounded-lg hover:bg-red-600 hover:text-white transition-colors"
            >
              Remover
            </button>
          </div>
        </div>
        <div class="flex flex-wrap gap-1.5 mt-2">
          <span *ngFor="let scope of app.scopes"
            class="px-2 py-0.5 text-[10px] font-medium rounded-full bg-westetics-purple-light text-westetics-purple-800">
            {{ getScopeLabel(scope) }}
          </span>
        </div>
        <div class="flex gap-4 mt-2 text-[10px] text-westetics-neutral-600">
          <span>Criado em: {{ app.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
          <span *ngIf="app.last_used_at">Último uso: {{ app.last_used_at | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ACTION (apenas no modo de criação) -->
  <div *ngIf="!isEditMode" class="flex flex-col sm:flex-row sm:justify-between gap-3 my-6">
    <button
      type="button"
      (click)="cancel()"
      class="flex-1 sm:flex-none sm:w-[280px] py-[10px] text-westetics-purple-800 rounded-lg border border-westetics-purple-800"
    >
      Cancelar
    </button>

    <button
      type="button"
      (click)="saveAndNext()"
      class="flex-1 sm:flex-none sm:w-[280px] py-[10px] bg-westetics-purple-800 text-white rounded-lg"
    >
      Próximo
    </button>
  </div>

</form>

<!-- MODAIS CLINIC APPS -->

<!-- Modal Criar App -->
<div *ngIf="showCreateAppModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-6 w-[440px] max-w-full shadow-lg">
    <div class="flex justify-between items-center mb-4">
      <h2 class="font-bold text-lg text-westetics-neutral-950">Novo App</h2>
      <button (click)="closeCreateAppModal()" type="button"
        class="text-westetics-neutral-600 hover:text-westetics-neutral-900 text-xl leading-none">&times;</button>
    </div>

    <div class="mb-4">
      <label class="block text-sm font-medium text-westetics-neutral-950 mb-1">Nome do App</label>
      <input type="text"
        [(ngModel)]="newAppName"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Ex: Meu App"
        class="w-full text-sm border border-gray-300 rounded-lg px-3 py-2 outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800" />
    </div>

    <div class="mb-4">
      <label class="block text-sm font-medium text-westetics-neutral-950 mb-2">Escopos</label>
      <div class="flex flex-col gap-2">
        <label *ngFor="let scope of availableScopes" class="flex items-center gap-2 cursor-pointer">
          <input type="checkbox"
            [checked]="isNewAppScopeSelected(scope.value)"
            (change)="toggleNewAppScope(scope.value)" />
          <span class="text-sm text-westetics-neutral-950">{{ scope.label }}</span>
        </label>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-6">
      <button type="button" (click)="closeCreateAppModal()"
        class="px-4 py-2 text-sm font-medium text-westetics-neutral-800 bg-westetics-neutral-200 rounded-lg hover:bg-westetics-neutral-300">
        Cancelar
      </button>
      <button type="button" (click)="createApp()"
        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600">
        Criar
      </button>
    </div>
  </div>
</div>

<!-- Modal Secret -->
<div *ngIf="showSecretModal && createdAppSecret" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-6 w-[500px] max-w-full shadow-lg">
    <div class="flex justify-between items-center mb-4">
      <h2 class="font-bold text-lg text-westetics-neutral-950">Credenciais do App</h2>
      <button (click)="closeSecretModal()" type="button"
        class="text-westetics-neutral-600 hover:text-westetics-neutral-900 text-xl leading-none">&times;</button>
    </div>

    <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
      <p class="text-xs text-amber-800 font-medium">⚠️ Atenção: O secret não será exibido novamente. Copie e guarde em um local seguro.</p>
    </div>

    <div class="mb-3">
      <label class="block text-xs font-medium text-westetics-neutral-600 mb-1">App Key</label>
      <code class="block text-xs bg-gray-50 border rounded-lg px-3 py-2 font-mono break-all select-all">{{ createdAppSecret.app_key }}</code>
    </div>

    <div class="mb-4">
      <label class="block text-xs font-medium text-westetics-neutral-600 mb-1">App Secret</label>
      <code class="block text-xs bg-gray-50 border rounded-lg px-3 py-2 font-mono break-all select-all">{{ createdAppSecret.app_secret }}</code>
    </div>

    <div class="flex justify-end gap-3">
      <button type="button" (click)="copyCredentials()"
        class="px-4 py-2 text-sm font-medium rounded-lg transition-colors"
        [ngClass]="credentialsCopied ? 'bg-green-100 text-green-700 border border-green-300' : 'text-westetics-purple-800 border border-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white'">
        {{ credentialsCopied ? 'Copiado!' : 'Copiar Informações' }}
      </button>
      <button type="button" (click)="closeSecretModal()"
        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600">
        Entendi
      </button>
    </div>
  </div>
</div>

<!-- Modal Editar Scopes -->
<div *ngIf="showEditScopesModal && editingApp" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-6 w-[440px] max-w-full shadow-lg">
    <div class="flex justify-between items-center mb-4">
      <h2 class="font-bold text-lg text-westetics-neutral-950">Editar Escopos</h2>
      <button (click)="closeEditScopesModal()" type="button"
        class="text-westetics-neutral-600 hover:text-westetics-neutral-900 text-xl leading-none">&times;</button>
    </div>

    <p class="text-sm text-westetics-neutral-800 mb-1">App: <strong>{{ editingApp.name }}</strong></p>
    <p class="text-xs text-westetics-neutral-600 mb-4">Selecione os escopos que este app pode acessar.</p>

    <div class="flex flex-col gap-2 mb-6">
      <label *ngFor="let scope of availableScopes" class="flex items-center gap-2 cursor-pointer">
        <input type="checkbox"
          [checked]="isEditScopeSelected(scope.value)"
          (change)="toggleEditScope(scope.value)" />
        <span class="text-sm text-westetics-neutral-950">{{ scope.label }}</span>
      </label>
    </div>

    <div class="flex justify-end gap-3">
      <button type="button" (click)="closeEditScopesModal()"
        class="px-4 py-2 text-sm font-medium text-westetics-neutral-800 bg-westetics-neutral-200 rounded-lg hover:bg-westetics-neutral-300">
        Cancelar
      </button>
      <button type="button" (click)="saveScopes()"
        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600">
        Salvar
      </button>
    </div>
  </div>
</div>

<!-- Modal Confirmar Exclusão -->
<div *ngIf="showDeleteAppModal && deletingApp"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
  (click)="onDeleteModalBackdropClick($event)">
  <div class="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 relative">

    <!-- Estado 1: Confirmação -->
    <ng-container *ngIf="deleteAppStep === 'confirm'">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-westetics-neutral-950">Remover App</h3>
          <p class="text-sm text-westetics-neutral-600">Essa ação não pode ser desfeita.</p>
        </div>
      </div>
      <p class="text-sm text-westetics-neutral-700 mb-6">
        O app <strong>{{ deletingApp.name }}</strong> será desativado e não poderá mais acessar a API. Tem certeza que deseja continuar?
      </p>
      <div class="flex gap-3 justify-end">
        <button type="button" (click)="closeDeleteAppModal()"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 text-westetics-neutral-800 hover:bg-gray-50">
          Cancelar
        </button>
        <button type="button" (click)="confirmDeleteApp()"
          class="px-4 py-2 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700">
          Sim, remover app
        </button>
      </div>
    </ng-container>

    <!-- Estado 2: Loading -->
    <ng-container *ngIf="deleteAppStep === 'loading'">
      <div class="flex flex-col items-center justify-center py-8">
        <svg class="animate-spin h-10 w-10 text-westetics-purple-800 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-sm text-westetics-neutral-700">Removendo app...</p>
      </div>
    </ng-container>

  </div>
</div>

<!-- Modal Confirmar Regenerar Secret -->
<div *ngIf="showRegenerateConfirmModal && regeneratingApp"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
  (click)="onRegenerateModalBackdropClick($event)">
  <div class="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 relative">

    <!-- Estado 1: Confirmação -->
    <ng-container *ngIf="regenerateAppStep === 'confirm'">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-westetics-neutral-950">Regenerar Secret</h3>
          <p class="text-sm text-westetics-neutral-600">Essa ação não pode ser desfeita.</p>
        </div>
      </div>
      <p class="text-sm text-westetics-neutral-700 mb-6">
        O secret atual do app <strong>{{ regeneratingApp.name }}</strong> será invalidado e um novo será gerado. Qualquer integração usando o secret atual deixará de funcionar. Tem certeza que deseja continuar?
      </p>
      <div class="flex gap-3 justify-end">
        <button type="button" (click)="closeRegenerateConfirmModal()"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 text-westetics-neutral-800 hover:bg-gray-50">
          Cancelar
        </button>
        <button type="button" (click)="confirmRegenerateSecret()"
          class="px-4 py-2 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700">
          Sim, regenerar secret
        </button>
      </div>
    </ng-container>

    <!-- Estado 2: Loading -->
    <ng-container *ngIf="regenerateAppStep === 'loading'">
      <div class="flex flex-col items-center justify-center py-8">
        <svg class="animate-spin h-10 w-10 text-westetics-purple-800 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-sm text-westetics-neutral-700">Regenerando secret...</p>
      </div>
    </ng-container>

  </div>
</div>

<!-- MODAL DE VISUALIZAÇÃO DA IMAGEM -->
<div 
  *ngIf="showImagePreview" 
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
  (click)="closeImagePreview()"
>
  <div class="relative max-w-[90vw] max-h-[90vh]" (click)="$event.stopPropagation()">
    <!-- Botão de fechar -->
    <button
      type="button"
      (click)="closeImagePreview()"
      class="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
    >
      <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
    
    <!-- Imagem ampliada -->
    <img
      [src]="getLogoUrl()"
      class="max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
      alt="Logo da empresa"
    />
  </div>
</div>
